import styles from './contact.module.scss'
import BusinessCard from './BusinessCard'

interface ContactProps {
    contactRef: React.RefObject<HTMLDivElement>;
}

const Contact: React.FC<ContactProps> = ({ contactRef }) => {
    return (
        <div className={styles.contact} ref={contactRef}>
            <div className={styles.top}>
                <div className={styles.label}>Contact</div>
                <h2 className={styles.heading}>Let's work together.</h2>
                <p className={styles.sub}>Have a project in mind? We'd love to hear about it.</p>
            </div>

            <div className={styles.cardWrap}>
                <BusinessCard />
                <div className={styles.hintPill}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                    Hover to flip
                </div>
            </div>
        </div>
    );
};

export default Contact;
